/** Browser-facing MinIO origin in local dev (matches typical page hostname). */
export const LOCAL_DEV_BROWSER_STORAGE_ORIGIN = 'http://localhost:9000';

/** Align loopback MinIO URLs with localhost so CSP and page origin match in local dev. */
export function normalizeLoamifyBrowserMediaUrl(
  url: string | null | undefined,
  nodeEnv: string | undefined = typeof process !== 'undefined' ? process.env.NODE_ENV : undefined,
): string | null | undefined {
  if (!url?.trim()) return url;
  if (nodeEnv === 'production') return url;
  try {
    const parsed = new URL(url);
    if (parsed.hostname === '127.0.0.1' && (parsed.port === '9000' || !parsed.port)) {
      parsed.hostname = 'localhost';
      return parsed.toString();
    }
  } catch {
    // keep original
  }
  return url;
}
